var _path, _ellipse, _g, _ellipse2, _path2, _path3, _path4, _path5, _path6, _g2, _g3, _g4, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldMembershipCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 429,
    height: 607,
    viewBox: "0 0 429 607",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2166_728)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2166_728)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 167.235C0 83.6174 0 41.8087 11.583 20.9043C23.166 0 46.332 0 92.664 0H336.336C382.668 0 405.834 0 417.417 20.9043C429 41.8087 429 83.6174 429 167.235V439.765C429 523.383 429 565.191 417.417 586.096C405.834 607 382.668 607 336.336 607H120.5C74.168 607 23.166 607 11.583 586.096C0 565.191 0 523.383 0 439.765V167.235Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 391.413,
    cy: 575.501,
    rx: 233.503,
    ry: 233.501,
    fill: "#FFDD53"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2166_728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.91 775.073C501.856 775.073 590.986 685.945 590.986 575.999C590.986 466.053 501.856 376.925 391.91 376.925C281.963 376.925 192.834 466.053 192.834 575.999C192.834 685.945 281.963 775.073 391.91 775.073Z",
    stroke: "#CF9A09",
    strokeWidth: 19.9574
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2166_728",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 158,
    y: 342,
    width: 468,
    height: 468
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 392.409,
    cy: 576.498,
    rx: 233.503,
    ry: 233.501,
    fill: "#EFBA80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M392.91 776.07C502.856 776.07 591.986 686.942 591.986 576.996C591.986 467.05 502.856 377.922 392.91 377.922C282.963 377.922 193.834 467.05 193.834 576.996C193.834 686.942 282.963 776.07 392.91 776.07Z",
    stroke: "#8C5B24",
    strokeWidth: 19.9574
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M395.41 720.026C395.41 720.635 395.919 721.123 396.527 721.096C448.89 718.794 490.635 675.615 490.635 622.685C490.635 620.252 490.546 617.838 490.372 615.446L490.372 511.57C490.372 510.656 489.307 510.157 488.605 510.742L456.284 537.675C455.765 538.108 454.981 537.961 454.652 537.371L397.429 434.446C396.889 433.474 395.41 433.858 395.41 434.97L395.41 484.594C395.41 484.778 395.456 484.958 395.545 485.118L447.104 577.855C447.433 578.445 448.217 578.592 448.736 578.159L462.336 566.826C463.038 566.242 464.103 566.741 464.103 567.654L464.103 616.452L464.143 616.963C464.291 618.849 464.366 620.757 464.366 622.685C464.366 661.132 434.33 692.565 396.443 694.797C395.867 694.831 395.41 695.305 395.41 695.881L395.41 720.026Z",
    fill: "#8C5B24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M395.41 685.275C395.41 685.896 395.936 686.389 396.554 686.339C424.369 684.086 446.24 660.8 446.24 632.405C446.24 618.894 441.273 606.517 433.087 597.041C433.038 596.984 432.995 596.923 432.959 596.858L397.429 532.954C396.889 531.982 395.41 532.366 395.41 533.478L395.41 583.102C395.41 583.285 395.456 583.465 395.545 583.625L411.465 612.258C411.506 612.333 411.557 612.402 411.615 612.465L412.593 613.525C417.184 618.498 419.971 625.111 419.971 632.405C419.971 646.343 409.73 657.889 396.361 659.929C395.82 660.011 395.41 660.469 395.41 661.016L395.41 685.275Z",
    fill: "#8C5B24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M387.891 659.929C388.432 660.011 388.842 660.469 388.842 661.016L388.842 685.275C388.842 685.896 388.316 686.389 387.698 686.339C359.883 684.086 338.012 660.8 338.012 632.405C338.012 618.894 342.979 606.517 351.166 597.04C351.215 596.984 351.258 596.923 351.294 596.858L386.823 532.955C387.363 531.983 388.842 532.366 388.842 533.478L388.842 583.102C388.842 583.285 388.796 583.466 388.707 583.626L372.788 612.258C372.746 612.332 372.696 612.402 372.638 612.465L371.66 613.524C367.068 618.498 364.281 625.111 364.281 632.405C364.281 646.343 374.523 657.889 387.891 659.929Z",
    fill: "#8C5B24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M388.842 484.594C388.842 484.778 388.796 484.958 388.707 485.118L337.064 578.004C336.736 578.595 335.952 578.741 335.433 578.309L321.654 566.826C320.952 566.242 319.886 566.741 319.886 567.654L319.886 622.685C319.886 661.132 349.922 692.565 387.809 694.797C388.385 694.831 388.842 695.305 388.842 695.881L388.842 720.026C388.842 720.635 388.334 721.123 387.725 721.096C335.362 718.794 293.617 675.615 293.617 622.685L293.617 511.57C293.617 510.656 294.683 510.157 295.385 510.742L327.885 537.825C328.404 538.257 329.188 538.111 329.516 537.52L386.823 434.446C387.363 433.474 388.842 433.858 388.842 434.97L388.842 484.594Z",
    fill: "#8C5B24"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2166_728)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2166_728)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -39.9148,
    x2: 520.1,
    y2: -39.9148,
    transform: "matrix(0.866027 -0.499997 0.500003 0.866024 186.844 685.872)",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 79.8296
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_2166_728)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -15.9659,
    x2: 520.1,
    y2: -15.9659,
    transform: "matrix(0.866027 -0.499997 0.500003 0.866024 233.555 750.075)",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 31.9319
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_2166_728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.414 719.029C394.414 719.638 394.922 720.126 395.531 720.099C447.894 717.797 489.639 674.618 489.639 621.688C489.639 619.255 489.55 616.841 489.376 614.449L489.376 510.573C489.376 509.659 488.311 509.16 487.609 509.745L455.288 536.678C454.769 537.11 453.985 536.964 453.656 536.374L396.433 433.449C395.893 432.477 394.414 432.861 394.414 433.973L394.414 483.597C394.414 483.78 394.46 483.961 394.549 484.121L446.108 576.858C446.437 577.448 447.221 577.595 447.74 577.162L461.34 565.829C462.042 565.244 463.107 565.744 463.107 566.657L463.107 615.455L463.147 615.966C463.295 617.852 463.37 619.76 463.37 621.688C463.37 660.135 433.334 691.567 395.447 693.8C394.871 693.834 394.414 694.308 394.414 694.884L394.414 719.029Z",
    fill: "#CF9A09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.414 684.278C394.414 684.899 394.94 685.392 395.558 685.342C423.373 683.089 445.244 659.803 445.244 631.407C445.244 617.897 440.277 605.52 432.09 596.044C432.042 595.987 431.999 595.926 431.963 595.861L396.433 531.957C395.893 530.985 394.414 531.369 394.414 532.481L394.414 582.104C394.414 582.288 394.46 582.468 394.549 582.628L410.469 611.261C410.51 611.336 410.561 611.405 410.619 611.468L411.597 612.528C416.188 617.501 418.975 624.114 418.975 631.407C418.975 645.346 408.734 656.892 395.365 658.932C394.824 659.014 394.414 659.472 394.414 660.019L394.414 684.278Z",
    fill: "#CF9A09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.895 658.932C387.436 659.014 387.846 659.472 387.846 660.018L387.846 684.278C387.846 684.899 387.32 685.392 386.702 685.342C358.887 683.089 337.016 659.803 337.016 631.407C337.016 617.897 341.983 605.52 350.17 596.043C350.219 595.987 350.261 595.926 350.298 595.861L385.827 531.958C386.367 530.986 387.846 531.369 387.846 532.481L387.846 582.105C387.846 582.288 387.8 582.469 387.711 582.629L371.792 611.26C371.75 611.335 371.7 611.405 371.642 611.468L370.663 612.527C366.072 617.5 363.285 624.114 363.285 631.407C363.285 645.346 373.526 656.892 386.895 658.932Z",
    fill: "#CF9A09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.846 483.597C387.846 483.78 387.8 483.961 387.711 484.121L336.068 577.007C335.74 577.598 334.956 577.744 334.437 577.311L320.658 565.829C319.956 565.244 318.89 565.744 318.89 566.657L318.89 621.688C318.89 660.135 348.926 691.567 386.813 693.8C387.389 693.834 387.846 694.308 387.846 694.884L387.846 719.029C387.846 719.638 387.337 720.126 386.729 720.099C334.366 717.797 292.621 674.618 292.621 621.688L292.621 510.573C292.621 509.659 293.687 509.16 294.389 509.745L326.889 536.827C327.408 537.26 328.192 537.114 328.52 536.523L385.827 433.449C386.367 432.477 387.846 432.861 387.846 433.973L387.846 483.597Z",
    fill: "#CF9A09"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2166_728)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286.215,
    y: -55.8613,
    width: 270,
    height: 42,
    rx: 4,
    transform: "rotate(40 286.215 -55.8613)",
    fill: "#512D9A"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_2166_728)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -7.36887,
    x2: 96.0179,
    y2: -7.36887,
    transform: "matrix(0.997427 -0.0716847 0.0716834 0.997427 327.039 52.3789)",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 14.7377
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_2166_728)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -2.94755,
    x2: 96.0179,
    y2: -2.94755,
    transform: "matrix(0.997427 -0.0716847 0.0716834 0.997427 329.617 66.8086)",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 5.89509
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 286.276,
    y: -55.1569,
    width: 269,
    height: 41,
    rx: 3.5,
    transform: "rotate(40 286.276 -55.1569)",
    stroke: "black",
    strokeOpacity: 0.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2166_728",
    x: -4,
    y: -4,
    width: 437,
    height: 615,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2166_728"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2166_728",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2166_728",
    x: 182.855,
    y: 366.946,
    width: 418.109,
    height: 422.098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.99148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.99148
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.180392 0 0 0 0 0.180392 0 0 0 0 0.180392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2166_728"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2166_728",
    x: 107.014,
    y: 316.775,
    width: 570.165,
    height: 409.012,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.9574,
    result: "effect1_foregroundBlur_2166_728"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2166_728",
    x: 177.674,
    y: 422.458,
    width: 546.216,
    height: 367.532,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.9574,
    result: "effect1_foregroundBlur_2166_728"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_2166_728",
    x: 292.621,
    y: 432.893,
    width: 197.018,
    height: 291.199,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.99148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.98722
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.608333 0 0 0 0 0.445497 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2166_728"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_2166_728",
    x: 316.982,
    y: 21.7959,
    width: 114.828,
    height: 39.583,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "effect1_foregroundBlur_2166_728"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_2166_728",
    x: 319.195,
    y: 44.0459,
    width: 116.193,
    height: 32.7627,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_2166_728"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2166_728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 429,
    height: 607,
    rx: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2166_728"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286.215,
    y: -55.8613,
    width: 270,
    height: 42,
    rx: 4,
    transform: "rotate(40 286.215 -55.8613)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldMembershipCard);
export default __webpack_public_path__ + "static/media/gold-membership-card.5a0fe7ae54e8f40fd15a35c6092595c7.svg";
export { ForwardRef as ReactComponent };